import { Colors, Pills, Text } from '@amelio/ui-library';

import { TABLE_CELL } from '../calibrationStyles';
import { formatScore } from '../utils/formatScore';

import type { CalibrationPerformanceLevel } from '@/types/calibration';

import { useAmelioTranslations } from '@/hooks';
import { getLocalizedText } from '@/utils/localization';

export interface PublishedAdjustmentCellsProps {
    score: number;
    /** `undefined` when the published adjustment carries no level of its own. */
    level: CalibrationPerformanceLevel | undefined;
    comment: string | null;
    language: string;
}

/** Calibrated score, level and comment of a published adjustment: values, never fields — a
 * published row has nothing left to edit until it is reopened. */
export const PublishedAdjustmentCells = ({
    score,
    level,
    comment,
    language,
}: PublishedAdjustmentCellsProps) => {
    const { t } = useAmelioTranslations();

    return (
        <>
            <td className={TABLE_CELL}>
                <Text
                    weight={'semibold'}
                    color={Colors.NAVY}
                >
                    {formatScore({ value: score, language })}
                </Text>
            </td>

            <td className={TABLE_CELL}>
                {level && (
                    <Pills
                        size={'sm'}
                        variant={'default'}
                    >
                        {getLocalizedText(level.label)}
                    </Pills>
                )}
            </td>

            <td className={TABLE_CELL}>
                <Text color={Colors.BASE_500}>{comment ?? t('calibration.table.status.none')}</Text>
            </td>
        </>
    );
};
